import { SearchOutlined } from "@ant-design/icons";
import { Input, Select, Table } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";
import { debounce, DebounceCounter } from "src/common/debounce";

import * as styles from "./AttrTransferPart.module.less";
import { AttrTransferPartStore } from "./AttrTransferPartStore";
import { AttrDetails } from "./buildAttrsList";

type PropsAttrTransferPart = {
  store: AttrTransferPartStore;
  title: string;
};

export const AttrTransferPart: React.FC<PropsAttrTransferPart> = observer(
  (props) => {
    const { store, title } = props;

    const refTbl = React.useRef<HTMLDivElement>(null);
    const [tblHeight, setTblHeight] = React.useState(100);
    const [attrSearch, setAttrSearch] = React.useState("");
    const onSearch = (value: string) => {
      setAttrSearch(value);
      debounce(searchCounter, 300, () => {
        store.setSearch(value);
      });
    };

    React.useEffect(() => {
      const setHeight = () => {
        const { current } = refTbl;
        if (current) {
          let h = current.clientHeight;
          const thead = current.querySelector("thead");
          if (thead) h -= thead.offsetHeight;
          setTblHeight(h);
        }
      };
      setTimeout(() => setHeight(), 10);
      const onResize = () => {
        setHeight();
      };
      window.addEventListener("resize", onResize);
      return () => {
        window.removeEventListener("resize", onResize);
      };
    }, []);

    return (
      <div className={styles.frame}>
        <div className={styles.title}>{title}</div>
        <div className={styles.filters}>
          <Select
            placeholder="Выбрать спецификацию"
            options={store.specOptions}
            mode="multiple"
            maxTagCount="responsive"
            allowClear
            value={store.visibleSpecIds}
            onChange={(value: string[]) => store.setVisibleSpecIds(value)}
          />
          <Input
            prefix={<SearchOutlined style={{ color: "rgba(0, 0, 0, 0.30)" }} />}
            placeholder="Найти атрибут"
            allowClear
            value={attrSearch}
            onChange={(e) => onSearch(e.currentTarget.value)}
          />
        </div>
        <div ref={refTbl} className={styles.tableBox}>
          <Table<AttrDetails>
            rowKey="uid"
            columns={store.columns}
            dataSource={store.rows}
            pagination={false}
            scroll={{ y: tblHeight }}
            components={{
              body: {
                row: Row,
              },
            }}
            // @ts-ignore
            onRow={({ uid }) => ({ uid, store })}
          />
        </div>
      </div>
    );
  },
);

type PropsRow = {
  store?: AttrTransferPartStore;
  uid: string;
};

const Row: React.FC<React.PropsWithChildren<PropsRow>> = observer((props) => {
  const { children, store, uid } = props;
  const check = store?.selected[uid];
  return (
    <tr
      className={classNames([
        [check === "all" || check === "partial", styles.selectedRow],
      ])}
    >
      {children}
    </tr>
  );
});

const searchCounter: DebounceCounter = {};
